export default __webpack_public_path__ + "static/media/ic_racikan.e24de577.png";